import { LDSSkeleton } from "@resmed/lumina-design-system";

/**
 * Placeholder row that mirrors the layout of ConversationListItem.
 * Rendered while the inbox API is loading.
 */
const SkeletonConversationListItem = () => (
  <div className="lds-flex lds-items-center lds-gap-3 lds-px-4 lds-py-3">
    {/* Avatar circle */}
    <LDSSkeleton shape="circle" width="3rem" height="3rem" />

    {/* Title + subtitle */}
    <div className="lds-flex lds-flex-col lds-flex-1 lds-min-w-0 lds-gap-2">
      <LDSSkeleton shape="rectangle" width="65%" height="0.875rem" />
      <LDSSkeleton shape="rectangle" width="45%" height="0.75rem" />
    </div>

    {/* Time */}
    <LDSSkeleton shape="rectangle" width="4rem" height="0.75rem" />
  </div>
);

export default SkeletonConversationListItem;
